// Base URL per le API
const API_BASE_URL = process.env.NODE_ENV === 'production'
  ? '/api'
  : 'http://localhost:8080/api';

// Helper per chiamate API
export const apiCall = async (endpoint, options = {}) => {
  const url = `${API_BASE_URL}${endpoint}`;

  try {
    const response = await fetch(url, {
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });

    if (!response.ok) {
      // Try to parse the error body so callers can access errorCode, etc.
      let errBody = null;
      try { errBody = await response.json(); } catch (e) { /* not json */ }
      const error = new Error(errBody?.error || `API Error: ${response.status}`);
      error.status = response.status;
      error.body = errBody;
      error.errorCode = errBody?.errorCode;
      throw error;
    }

    return await response.json();
  } catch (error) {
    console.error('API call failed:', error);
    throw error;
  }
};

// API Endpoints
export const API = {
  // Prodotti
  getProducts: (params = {}) => {
    const query = new URLSearchParams(params).toString();
    return apiCall(`/products${query ? `?${query}` : ''}`);
  },

  getProduct: (id) => apiCall(`/products/${id}`),

  // Categorie
  getCategories: () => apiCall('/categories'),

  // Try-On
  tryOn: (data) => apiCall('/try-on', {
    method: 'POST',
    body: JSON.stringify(data),
  }),

  // Upload foto
  uploadPhoto: (photoData, userId) => apiCall('/upload-photo', {
    method: 'POST',
    body: JSON.stringify({ photoData, userId }),
  }),

  // Preferiti (richiede autenticazione)
  getFavorites: (userId, token) => apiCall(`/favorites?userId=${userId}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  }),

  addFavorite: (productId, userId, token) => apiCall('/favorites', {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ productId, userId }),
  }),

  removeFavorite: (productId, userId, token) => apiCall(`/favorites/${productId}?userId=${userId}`, {
    method: 'DELETE',
    headers: {
      Authorization: `Bearer ${token}`,
    },
  }),

  // Statistiche
  getStats: () => apiCall('/stats'),
};

export default API;